import { CustomerInfo, SetCustomer } from './typings'

export const setCustomerActionCreator = (
  payload: CustomerInfo,
): SetCustomer => ({
  type: 'referrals/setCustomer',
  payload,
})
